import { useState, useMemo, useEffect } from 'react';

export default function CohortMRCDADPRO() {
  const [vista, setVista] = useState('polizas');
  const [showPct, setShowPct] = useState(false);
  const [selectedCia, setSelectedCia] = useState('GLOBAL');
  const [primaInicial, setPrimaInicial] = useState('');
  const [comisionProduccion, setComisionProduccion] = useState('');
  const [comisionCartera, setComisionCartera] = useState('');

  const years = [2015,2016,2017,2018,2019,2020,2021,2022,2023,2024,2025];
  const yLabels = years.map(String);

  // ============ POLIZAS DATA ============
  const polGlobal = {
    2015:[733,657,540,442,376,319,260,206,166,138,111],
    2016:[0,741,643,514,413,340,284,240,210,174,147],
    2017:[0,0,749,648,501,393,310,244,195,163,140],
    2018:[0,0,0,941,804,630,514,415,344,287,238],
    2019:[0,0,0,0,1243,1067,842,649,523,442,373],
    2020:[0,0,0,0,0,1530,1328,1061,851,680,500],
    2021:[0,0,0,0,0,0,1832,1606,1333,1035,841],
    2022:[0,0,0,0,0,0,0,2219,1962,1590,1253],
    2023:[0,0,0,0,0,0,0,0,2846,2476,2024],
    2024:[0,0,0,0,0,0,0,0,0,3643,3142],
    2025:[0,0,0,0,0,0,0,0,0,0,4641],
  };

  // Per-company polizas data - build from query results
  const polByCia = {
    'ALLIANZ': {
      2015:[41,36,26,20,15,15,13,11,9,6,6],2016:[0,42,34,29,21,16,14,12,12,10,9],
      2017:[0,0,61,49,33,28,21,19,15,10,7],2018:[0,0,0,146,112,83,69,52,41,29,26],
      2019:[0,0,0,0,251,205,160,111,83,65,53],2020:[0,0,0,0,0,148,129,99,75,59,50],
      2021:[0,0,0,0,0,0,52,40,36,24,19],2022:[0,0,0,0,0,0,0,28,26,22,16],
      2023:[0,0,0,0,0,0,0,0,68,56,43],2024:[0,0,0,0,0,0,0,0,0,153,130],
      2025:[0,0,0,0,0,0,0,0,0,0,328],
    },
    'AXA': {
      2015:[2,2,1,1,1,1,1,1,1,0,0],2016:[0,3,3,2,1,1,1,1,0,0,0],
      2018:[0,0,0,1,1,1,1,1,1,1,0],2019:[0,0,0,0,21,20,12,8,5,4,0],
      2020:[0,0,0,0,0,274,244,194,147,93,11],2021:[0,0,0,0,0,0,68,58,48,29,1],
      2022:[0,0,0,0,0,0,0,14,13,10,0],2023:[0,0,0,0,0,0,0,0,7,5,1],
      2024:[0,0,0,0,0,0,0,0,0,17,7],2025:[0,0,0,0,0,0,0,0,0,0,48],
    },
    'CASER': {
      2015:[8,8,7,5,5,5,3,2,2,1,1],2016:[0,67,62,48,42,39,35,28,25,21,17],
      2017:[0,0,46,44,33,27,21,17,16,14,10],2018:[0,0,0,64,59,45,36,25,22,20,17],
      2019:[0,0,0,0,31,26,20,17,13,12,10],2020:[0,0,0,0,0,27,21,14,11,8,6],
      2021:[0,0,0,0,0,0,58,43,34,23,19],2022:[0,0,0,0,0,0,0,78,68,49,31],
      2023:[0,0,0,0,0,0,0,0,68,55,42],2024:[0,0,0,0,0,0,0,0,0,95,72],
      2025:[0,0,0,0,0,0,0,0,0,0,108],
    },
    'FIATC': {
      2016:[0,1,0,0,0,0,0,0,0,0,0],2018:[0,0,0,1,1,0,0,0,0,0,0],
      2020:[0,0,0,0,0,9,8,6,4,2,2],2021:[0,0,0,0,0,0,79,71,46,24,17],
      2022:[0,0,0,0,0,0,0,71,52,30,25],2023:[0,0,0,0,0,0,0,0,28,22,18],
      2024:[0,0,0,0,0,0,0,0,0,12,9],2025:[0,0,0,0,0,0,0,0,0,0,17],
    },
    'GENERALI': {
      2015:[75,68,54,48,41,31,24,19,16,12,9],2016:[0,79,68,57,41,34,31,29,25,22,16],
      2017:[0,0,124,112,89,72,58,48,40,36,29],2018:[0,0,0,91,78,59,45,38,36,32,27],
      2019:[0,0,0,0,99,87,73,55,46,38,32],2020:[0,0,0,0,0,118,104,82,67,59,49],
      2021:[0,0,0,0,0,0,110,98,75,58,50],2022:[0,0,0,0,0,0,0,209,180,144,112],
      2023:[0,0,0,0,0,0,0,0,223,194,147],2024:[0,0,0,0,0,0,0,0,0,262,239],
      2025:[0,0,0,0,0,0,0,0,0,0,279],
    },
    'GENERALION': {
      2015:[159,137,109,85,70,62,56,53,42,33,28],2016:[0,127,102,80,64,54,43,38,34,31,28],
      2017:[0,0,97,84,69,57,47,37,29,26,24],2018:[0,0,0,164,145,124,104,89,73,65,53],
      2019:[0,0,0,0,195,175,145,124,99,82,65],2020:[0,0,0,0,0,218,190,160,129,117,97],
      2021:[0,0,0,0,0,0,198,178,139,110,88],2022:[0,0,0,0,0,0,0,125,113,92,70],
      2023:[0,0,0,0,0,0,0,0,103,80,57],2024:[0,0,0,0,0,0,0,0,0,199,161],
      2025:[0,0,0,0,0,0,0,0,0,0,265],
    },
    'HELVETIA': {
      2017:[0,0,24,23,20,16,14,7,6,5,3],2018:[0,0,0,26,25,18,14,10,6,2,2],
      2019:[0,0,0,0,31,27,20,14,8,7,6],2020:[0,0,0,0,0,40,36,27,14,8,6],
      2021:[0,0,0,0,0,0,64,38,31,23,16],2022:[0,0,0,0,0,0,0,37,31,20,13],
      2023:[0,0,0,0,0,0,0,0,52,42,27],2024:[0,0,0,0,0,0,0,0,0,49,36],
      2025:[0,0,0,0,0,0,0,0,0,0,27],
    },
    'MAPFRE': {
      2015:[7,6,5,5,5,4,4,2,1,1,1],2016:[0,17,17,14,10,7,4,3,3,3,3],
      2017:[0,0,11,10,8,6,6,6,5,2,2],2018:[0,0,0,48,47,40,33,30,27,20,16],
      2019:[0,0,0,0,152,143,128,112,100,89,82],2020:[0,0,0,0,0,203,187,161,141,118,96],
      2021:[0,0,0,0,0,0,478,454,410,322,266],2022:[0,0,0,0,0,0,0,693,648,557,445],
      2023:[0,0,0,0,0,0,0,0,720,655,562],2024:[0,0,0,0,0,0,0,0,0,607,547],
      2025:[0,0,0,0,0,0,0,0,0,0,801],
    },
    'MGS': {
      2022:[0,0,0,0,0,0,0,88,67,45,26],2023:[0,0,0,0,0,0,0,0,87,55,32],
      2024:[0,0,0,0,0,0,0,0,0,3,2],2025:[0,0,0,0,0,0,0,0,0,0,0],
    },
    'MUTUAP': {
      2015:[163,158,139,124,106,92,67,39,32,29,20],2016:[0,155,138,115,95,77,58,45,40,31,30],
      2017:[0,0,116,99,75,54,40,25,17,16,14],2018:[0,0,0,96,84,71,59,51,40,34,27],
      2019:[0,0,0,0,16,14,9,5,3,3,3],2020:[0,0,0,0,0,2,1,1,1,1,1],
      2021:[0,0,0,0,0,0,9,9,9,6,5],2022:[0,0,0,0,0,0,0,27,21,16,12],
      2023:[0,0,0,0,0,0,0,0,16,14,10],2024:[0,0,0,0,0,0,0,0,0,67,61],
      2025:[0,0,0,0,0,0,0,0,0,0,194],
    },
    'OCASO': {
      2015:[136,126,109,87,75,64,54,48,38,33,28],2016:[0,116,107,91,81,69,61,52,43,36,26],
      2017:[0,0,69,66,56,48,39,36,26,23,22],2018:[0,0,0,139,120,103,89,72,63,55,45],
      2019:[0,0,0,0,122,109,95,78,68,58,53],2020:[0,0,0,0,0,148,132,113,97,82,71],
      2021:[0,0,0,0,0,0,409,364,309,262,237],2022:[0,0,0,0,0,0,0,484,435,373,324],
      2023:[0,0,0,0,0,0,0,0,860,779,669],2024:[0,0,0,0,0,0,0,0,0,1215,1098],
      2025:[0,0,0,0,0,0,0,0,0,0,1377],
    },
    'OCCIDENT': {
      2015:[6,4,2,2,2,1,1,0,0,0,0],2016:[0,2,2,2,1,1,1,1,1,1,1],
      2017:[0,0,2,1,1,0,0,0,0,0,0],2018:[0,0,0,4,4,4,2,2,2,1,1],
      2019:[0,0,0,0,8,6,5,4,3,3,3],2020:[0,0,0,0,0,72,60,50,47,34,30],
      2021:[0,0,0,0,0,0,90,80,73,64,57],2022:[0,0,0,0,0,0,0,107,93,70,57],
      2023:[0,0,0,0,0,0,0,0,90,80,68],2024:[0,0,0,0,0,0,0,0,0,102,87],
      2025:[0,0,0,0,0,0,0,0,0,0,158],
    },
    'PLUSTRA': {
      2017:[0,0,1,1,1,1,1,1,1,0,0],2018:[0,0,0,1,1,1,1,1,1,1,1],
      2019:[0,0,0,0,1,1,1,1,0,0,0],2021:[0,0,0,0,0,0,2,2,1,1,1],
      2022:[0,0,0,0,0,0,0,24,22,18,12],2023:[0,0,0,0,0,0,0,0,19,13,8],
      2024:[0,0,0,0,0,0,0,0,0,13,12],2025:[0,0,0,0,0,0,0,0,0,0,16],
    },
    'REALE': {
      2015:[134,110,87,65,56,44,37,31,25,23,18],2016:[0,129,108,74,55,40,34,30,26,18,17],
      2017:[0,0,197,158,115,84,63,48,40,31,29],2018:[0,0,0,142,109,69,51,36,24,19,16],
      2019:[0,0,0,0,232,178,114,86,70,60,49],2020:[0,0,0,0,0,166,130,90,68,59,50],
      2021:[0,0,0,0,0,0,161,125,86,62,45],2022:[0,0,0,0,0,0,0,180,144,99,70],
      2023:[0,0,0,0,0,0,0,0,304,238,176],2024:[0,0,0,0,0,0,0,0,0,483,349],
      2025:[0,0,0,0,0,0,0,0,0,0,508],
    },
    'STLUCIA': {
      2015:[1,1,0,0,0,0,0,0,0,0,0],2016:[0,3,2,2,2,2,2,1,1,1,0],
      2017:[0,0,1,1,1,0,0,0,0,0,0],2018:[0,0,0,18,18,12,10,8,8,8,7],
      2019:[0,0,0,0,16,15,11,7,6,6,6],2020:[0,0,0,0,0,15,12,10,8,8,6],
      2021:[0,0,0,0,0,0,7,7,6,5,4],2022:[0,0,0,0,0,0,0,44,40,38,34],
      2023:[0,0,0,0,0,0,0,0,188,175,155],2024:[0,0,0,0,0,0,0,0,0,346,316],
      2025:[0,0,0,0,0,0,0,0,0,0,477],
    },
    'ZURICH': {
      2019:[0,0,0,0,68,61,49,27,19,15,11],2020:[0,0,0,0,0,90,74,54,42,32,25],
      2021:[0,0,0,0,0,0,47,39,30,22,16],2022:[0,0,0,0,0,0,0,10,9,7,6],
      2023:[0,0,0,0,0,0,0,0,13,13,9],2024:[0,0,0,0,0,0,0,0,0,18,14],
      2025:[0,0,0,0,0,0,0,0,0,0,31],
    },
  };

  // ============ RECIBOS DATA (Prima Neta €, rounded) ============
  const recGlobal = {
    2015:[573446,625808,522503,445932,392097,335283,283640,239668,199976,180010,167164],
    2016:[0,588988,575091,472910,365456,302915,249893,220396,213865,190322,176455],
    2017:[0,0,603283,582438,451907,377742,300529,244041,199716,182374,177299],
    2018:[0,0,0,708657,706178,569991,476867,395230,339901,313396,275349],
    2019:[0,0,0,0,935957,959614,814014,656286,573927,514007,466249],
    2020:[0,0,0,0,0,1108154,1166917,955442,834733,702962,569557],
    2021:[0,0,0,0,0,0,1561825,1614566,1379421,1169328,1029822],
    2022:[0,0,0,0,0,0,0,2007350,2213106,1902789,1666474],
    2023:[0,0,0,0,0,0,0,0,2788490,2997586,2622181],
    2024:[0,0,0,0,0,0,0,0,0,3912237,4229982],
    2025:[0,0,0,0,0,0,0,0,0,0,5410323],
  };

  const recByCia = {
    'ALLIANZ': {2015:[37313,35015,31196,25258,20899,20422,16752,16741,15782,10746,11893],2016:[0,42571,37338,30968,20741,14988,13221,13378,14864,12448,13863],2017:[0,0,53892,51126,35358,30134,21830,22606,18535,11454,9441],2018:[0,0,0,100288,84909,60976,56795,45211,38411,30729,28641],2019:[0,0,0,0,156354,166143,145001,110762,93524,73914,70138],2020:[0,0,0,0,0,102354,114048,96927,86568,71669,67589],2021:[0,0,0,0,0,0,33733,32504,35007,23794,22557],2022:[0,0,0,0,0,0,0,30331,40255,36933,24604],2023:[0,0,0,0,0,0,0,0,76537,73199,58375],2024:[0,0,0,0,0,0,0,0,0,137007,151862],2025:[0,0,0,0,0,0,0,0,0,0,389238]},
    'CASER': {2015:[7500,9791,8225,6751,7416,8016,4860,1735,1880,869,1027],2016:[0,30096,33840,23910,22271,22058,19210,18322,17489,18110,18104],2017:[0,0,20479,24967,20380,18149,13534,11933,12985,10195,8180],2018:[0,0,0,34562,36021,29726,25344,19894,18386,20964,19527],2019:[0,0,0,0,15849,13916,10047,8948,8197,8667,7736],2020:[0,0,0,0,0,16619,14539,11138,7400,6041,4201],2021:[0,0,0,0,0,0,44015,40777,33291,27980,27072],2022:[0,0,0,0,0,0,0,74302,74680,52868,37578],2023:[0,0,0,0,0,0,0,0,98593,93935,79376],2024:[0,0,0,0,0,0,0,0,0,131442,104661],2025:[0,0,0,0,0,0,0,0,0,0,173198]},
    'GENERALI': {2015:[41244,47860,38609,32844,27384,21250,17523,16989,15794,11300,9210],2016:[0,55763,63188,53141,31535,25184,24193,23768,21235,18717,16205],2017:[0,0,112615,104604,76422,67070,54727,46173,37162,35780,34191],2018:[0,0,0,73802,60562,44524,34900,28830,27389,27090,25171],2019:[0,0,0,0,73775,80070,68369,52698,46838,42512,34309],2020:[0,0,0,0,0,72931,77450,59508,49370,45741,41064],2021:[0,0,0,0,0,0,78712,84924,65525,51788,46501],2022:[0,0,0,0,0,0,0,169114,183436,148823,123941],2023:[0,0,0,0,0,0,0,0,226240,208874,155281],2024:[0,0,0,0,0,0,0,0,0,232788,274761],2025:[0,0,0,0,0,0,0,0,0,0,308264]},
    'GENERALION': {2015:[118495,129256,97288,71205,58681,52384,52029,52977,44558,39389,38163],2016:[0,110923,102787,87998,66909,57029,43497,37810,37407,35450,32173],2017:[0,0,78171,79358,68489,58817,49571,35405,31387,31222,31497],2018:[0,0,0,102017,110001,97412,83847,70850,58994,56541,50793],2019:[0,0,0,0,119416,126716,114673,103335,82492,70658,57933],2020:[0,0,0,0,0,111560,128293,112508,91431,93157,82286],2021:[0,0,0,0,0,0,144080,153835,123017,107759,87745],2022:[0,0,0,0,0,0,0,99111,106943,98410,82142],2023:[0,0,0,0,0,0,0,0,83480,80531,61246],2024:[0,0,0,0,0,0,0,0,0,167934,175264],2025:[0,0,0,0,0,0,0,0,0,0,274321]},
    'MAPFRE': {2015:[12501,13585,10483,11552,13217,13456,14249,12585,10097,11509,12781],2016:[0,19361,23877,21210,14496,11295,10176,8561,9746,10580,12131],2017:[0,0,11511,16685,10346,5149,5602,5566,2169,832,925],2018:[0,0,0,65301,86678,85475,60948,59865,47329,39462,32700],2019:[0,0,0,0,186868,191377,183284,147006,163963,154321,155290],2020:[0,0,0,0,0,201603,225513,197831,177083,164418,162758],2021:[0,0,0,0,0,0,420059,491226,471229,412171,385474],2022:[0,0,0,0,0,0,0,702466,818780,756366,694546],2023:[0,0,0,0,0,0,0,0,798060,936453,886080],2024:[0,0,0,0,0,0,0,0,0,870714,1066857],2025:[0,0,0,0,0,0,0,0,0,0,1152813]},
    'MUTUAP': {2015:[142372,163890,145478,140258,126590,110646,82050,49430,38783,37351,29384],2016:[0,150183,139762,122363,102290,84927,61646,50832,48075,40753,43957],2017:[0,0,130668,115728,86475,66026,46991,29932,23154,22536,22136],2018:[0,0,0,99085,99294,81761,64848,58869,46260,42068,33297],2019:[0,0,0,0,22106,22731,14234,8189,3125,3335,4064],2020:[0,0,0,0,0,1464,535,576,635,740,868],2021:[0,0,0,0,0,0,5273,6481,6103,4427,4783],2022:[0,0,0,0,0,0,0,23187,25081,19176,15022],2023:[0,0,0,0,0,0,0,0,30026,29891,20569],2024:[0,0,0,0,0,0,0,0,0,105512,123299],2025:[0,0,0,0,0,0,0,0,0,0,353434]},
    'OCASO': {2015:[108752,121215,105356,87294,75197,65228,55479,50358,42495,38693,37633],2016:[0,90008,96565,87711,75426,62283,55724,47546,46361,39831,25905],2017:[0,0,49429,57224,49797,50263,45224,45953,33629,35835,37859],2018:[0,0,0,96005,87455,82704,83449,60227,59402,59080,51126],2019:[0,0,0,0,83180,89935,86649,74130,69389,67419,58701],2020:[0,0,0,0,0,102520,119215,92563,85354,74300,67978],2021:[0,0,0,0,0,0,348244,345959,292817,257881,248144],2022:[0,0,0,0,0,0,0,373612,452547,424212,399416],2023:[0,0,0,0,0,0,0,0,765451,872497,802148],2024:[0,0,0,0,0,0,0,0,0,1239774,1341745],2025:[0,0,0,0,0,0,0,0,0,0,1470284]},
    'OCCIDENT': {2015:[8387,4548,2527,2609,938,947,234,0,0,0,0],2016:[0,1972,2578,794,214,224,235,247,262,282,306],2017:[0,0,1440,378,195,0,0,0,0,0,0],2018:[0,0,0,1368,1765,1165,575,611,654,313,339],2019:[0,0,0,0,4872,4932,4685,3894,3260,3802,4294],2020:[0,0,0,0,0,57897,61786,57108,57250,45460,39202],2021:[0,0,0,0,0,0,91482,96334,88129,89161,85307],2022:[0,0,0,0,0,0,0,112521,116210,94968,84332],2023:[0,0,0,0,0,0,0,0,112357,117215,108887],2024:[0,0,0,0,0,0,0,0,0,146216,169008],2025:[0,0,0,0,0,0,0,0,0,0,174137]},
    'REALE': {2015:[95452,98556,82229,67818,61422,42578,40102,38486,30190,30152,27073],2016:[0,82375,72843,43066,30196,23518,20870,18844,17445,13062,13811],2017:[0,0,119936,97888,75628,58149,43151,36336,32678,27603,28356],2018:[0,0,0,84927,75867,41610,32909,25534,22660,17932,18225],2019:[0,0,0,0,127472,114567,78746,65835,56056,52811,45643],2020:[0,0,0,0,0,97432,77798,53426,45527,42823,37722],2021:[0,0,0,0,0,0,81495,78025,54892,42875,30618],2022:[0,0,0,0,0,0,0,93206,90442,64573,49961],2023:[0,0,0,0,0,0,0,0,197006,190275,146291],2024:[0,0,0,0,0,0,0,0,0,409330,318427],2025:[0,0,0,0,0,0,0,0,0,0,412065]},
    'STLUCIA': {2015:[178,534,0,0,0,0,0,0,0,0,0],2016:[0,1846,1138,1152,1188,1221,931,893,982,1090,0],2017:[0,0,558,569,587,0,0,0,0,0,0],2018:[0,0,0,15774,19273,15176,12814,11717,12699,13829,11343],2019:[0,0,0,0,15113,13740,9854,5935,4572,5166,5625],2020:[0,0,0,0,0,13441,11915,11412,10609,10491,6797],2021:[0,0,0,0,0,0,5829,9415,8799,8145,6747],2022:[0,0,0,0,0,0,0,30677,39967,39102,40723],2023:[0,0,0,0,0,0,0,0,174869,214391,195255],2024:[0,0,0,0,0,0,0,0,0,365397,405123],2025:[0,0,0,0,0,0,0,0,0,0,506875]},
    'HELVETIA': {2017:[0,0,23860,32440,26701,22411,18256,8418,7118,6918,4715],2018:[0,0,0,32646,41405,27816,19304,11733,5715,3409,2853],2019:[0,0,0,0,37940,35239,22726,15448,9228,7965,8128],2020:[0,0,0,0,0,37179,44754,25469,15244,9419,7668],2021:[0,0,0,0,0,0,87101,53930,40920,35603,28467],2022:[0,0,0,0,0,0,0,47578,49175,33614,29324],2023:[0,0,0,0,0,0,0,0,47682,49017,24571],2024:[0,0,0,0,0,0,0,0,0,47408,41638],2025:[0,0,0,0,0,0,0,0,0,0,35133]},
    'ZURICH': {2019:[0,0,0,0,65711,65284,44920,29635,24381,21566,14388],2020:[0,0,0,0,0,78369,63361,48128,41967,37244,34759],2021:[0,0,0,0,0,0,54762,49618,39840,32787,29843],2022:[0,0,0,0,0,0,0,10458,10735,10188,8474],2023:[0,0,0,0,0,0,0,0,18391,22454,14651],2024:[0,0,0,0,0,0,0,0,0,17532,16839],2025:[0,0,0,0,0,0,0,0,0,0,43475]},
  };

  const mainCompanies = ['OCASO','MAPFRE','REALE','GENERALI','GENERALION','ALLIANZ','STLUCIA','MUTUAP','CASER','OCCIDENT','HELVETIA','AXA','ZURICH','FIATC','MGS','PLUSTRA'];
  const ciaColors = {'OCASO':'#2563EB','MAPFRE':'#DC2626','REALE':'#059669','GENERALI':'#7C3AED','GENERALION':'#EA580C','ALLIANZ':'#4F46E5','STLUCIA':'#0891B2','MUTUAP':'#BE185D','CASER':'#15803D','OCCIDENT':'#CA8A04','HELVETIA':'#9333EA','AXA':'#1D4ED8','ZURICH':'#0D9488','FIATC':'#B45309','MGS':'#6366F1','PLUSTRA':'#64748B'};

  // Comisiones por compañía: { produccion: %, cartera: % }
  const comisionesPorCia = {
    'MAPFRE':     { produccion: 27, cartera: 22 },
    'OCASO':      { produccion: 34, cartera: 24 },
    'GENERALI':   { produccion: 27, cartera: 21.5 },
    'REALE':      { produccion: 27, cartera: 20 },
    'STLUCIA':    { produccion: 34, cartera: 26 },
    'GENERALION': { produccion: 25, cartera: 25 },
    'ALLIANZ':    { produccion: 28, cartera: 20 },
    'OCCIDENT':   { produccion: 28, cartera: 20 },
    'MUTUAP':     { produccion: 25, cartera: 25 },
    'CASER':      { produccion: 20, cartera: 23 },
    'HELVETIA':   { produccion: 25, cartera: 25 },
    'ZURICH':     { produccion: 22, cartera: 22 },
    'AXA':        { produccion: 20, cartera: 20 },
    'FIATC':      { produccion: 22.5, cartera: 22.5 },
    'GLOBAL':     { produccion: 25, cartera: 22 },
  };

  // Precargar comisiones cuando cambia la compañía seleccionada
  useEffect(() => {
    const comisiones = comisionesPorCia[selectedCia] || comisionesPorCia['GLOBAL'];
    setComisionProduccion(comisiones.produccion.toString());
    setComisionCartera(comisiones.cartera.toString());
  }, [selectedCia]);

  const getCurrentData = () => {
    if (selectedCia === 'GLOBAL') return vista === 'polizas' ? polGlobal : recGlobal;
    return vista === 'polizas' ? (polByCia[selectedCia] || {}) : (recByCia[selectedCia] || {});
  };

  const data = getCurrentData();
  const cohortYears = Object.keys(data).map(Number).sort((a,b) => a - b);

  const getInit = (row) => { for (let i = 0; i < row.length; i++) { if (row[i] > 0) return row[i]; } return 0; };

  // Calcular patrones de retención promedio basados en datos históricos
  const calcRetentionPatterns = useMemo(() => {
    const recData = selectedCia === 'GLOBAL' ? recGlobal : (recByCia[selectedCia] || {});
    const retentionsByYear = { 1: [], 2: [], 3: [], 4: [], 5: [] };

    Object.keys(recData).forEach(cohortYear => {
      const cy = Number(cohortYear);
      const row = recData[cy];
      if (!row) return;

      let init = 0;
      let cyIdx = -1;
      for (let i = 0; i < row.length; i++) {
        if (row[i] > 0) { init = row[i]; cyIdx = i; break; }
      }
      if (init <= 0 || cyIdx === -1) return;

      for (let offset = 1; offset <= 5; offset++) {
        const targetIdx = cyIdx + offset;
        if (targetIdx < row.length && row[targetIdx] > 0) {
          const retention = (row[targetIdx] / init) * 100;
          retentionsByYear[offset].push(retention);
        }
      }
    });

    const defaultRetentions = { 1: 87, 2: 69, 3: 56, 4: 45, 5: 33 };
    const averages = {};

    for (let year = 1; year <= 5; year++) {
      const values = retentionsByYear[year];
      if (values.length >= 2) {
        const sorted = [...values].sort((a, b) => a - b);
        const trimmed = values.length >= 4 ? sorted.slice(1, -1) : sorted;
        averages[year] = trimmed.reduce((a, b) => a + b, 0) / trimmed.length;
      } else if (values.length === 1) {
        averages[year] = values[0];
      } else {
        averages[year] = defaultRetentions[year];
      }
    }

    return averages;
  }, [selectedCia, recGlobal, recByCia]);

  // Calcular proyección a 5 años
  const proyeccion5Anios = useMemo(() => {
    const prima = parseFloat(primaInicial.replace(/,/g, '').replace(/\./g, '')) || 0;
    const comProd = parseFloat(comisionProduccion) || 0;
    const comCart = parseFloat(comisionCartera) || 0;

    if (prima <= 0) return null;

    const resultado = [];

    for (let year = 1; year <= 5; year++) {
      const retencionPct = calcRetentionPatterns[year] || 0;
      const primaProyectada = prima * (retencionPct / 100);
      // Año 1 = Producción, Años 2-5 = Cartera
      const comisionAplicada = year === 1 ? comProd : comCart;
      const comisionGenerada = primaProyectada * (comisionAplicada / 100);

      resultado.push({
        ano: year,
        retencionPct,
        primaProyectada,
        comisionPct: comisionAplicada,
        comision: comisionGenerada
      });
    }

    const totalPrima = resultado.reduce((sum, r) => sum + r.primaProyectada, 0);
    const totalComision = resultado.reduce((sum, r) => sum + r.comision, 0);

    return {
      proyecciones: resultado,
      totales: { primaAcumulada: totalPrima, comisionAcumulada: totalComision }
    };
  }, [primaInicial, comisionProduccion, comisionCartera, calcRetentionPatterns]);

  const getColor = (val, init) => {
    if (val === 0 || init === 0) return 'transparent';
    const pct = (val / init) * 100;
    if (pct >= 95) return 'rgba(30, 64, 175, 0.85)';
    if (pct >= 80) return 'rgba(37, 99, 235, 0.75)';
    if (pct >= 60) return 'rgba(59, 130, 246, 0.6)';
    if (pct >= 40) return 'rgba(96, 165, 250, 0.45)';
    if (pct >= 20) return 'rgba(147, 197, 253, 0.35)';
    if (pct >= 10) return 'rgba(191, 219, 254, 0.3)';
    return 'rgba(219, 234, 254, 0.2)';
  };

  const getTextColor = (val, init) => {
    if (val === 0) return 'transparent';
    const pct = init > 0 ? (val / init) * 100 : 0;
    return pct >= 60 ? '#ffffff' : '#e2e8f0';
  };

  const fmt = (v, isRec) => {
    if (v === 0) return '';
    if (showPct) return v.toFixed(0) + '%';
    if (isRec) { if (v >= 1000000) return (v/1000000).toFixed(1)+'M'; if (v >= 1000) return (v/1000).toFixed(0)+'k'; return v.toFixed(0); }
    return v.toLocaleString('es-ES');
  };

  const fmtInit = (v, isRec) => {
    if (isRec) { if (v >= 1000000) return (v/1000000).toFixed(1)+'M'; if (v >= 1000) return (v/1000).toFixed(0)+'k'; return v.toFixed(0); }
    return v.toLocaleString('es-ES');
  };

  const isRec = vista === 'recibos';

  const sty = {
    page: { minHeight:'100vh', background:'linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0f172a 100%)', fontFamily:"'Söhne','Helvetica Neue',Helvetica,Arial,sans-serif", color:'#e2e8f0', padding:'24px 16px' },
    wrap: { maxWidth:1500, margin:'0 auto' },
    badge: { display:'inline-block', background:'linear-gradient(135deg,#dc2626,#ef4444)', padding:'5px 16px', borderRadius:6, marginBottom:12, fontSize:11, fontWeight:700, letterSpacing:2, textTransform:'uppercase', color:'#fff' },
    h1: { fontSize:32, fontWeight:800, margin:0, background:'linear-gradient(135deg,#f8fafc,#94a3b8)', WebkitBackgroundClip:'text', WebkitTextFillColor:'transparent', letterSpacing:-1 },
    sub: { color:'#64748b', fontSize:14, marginTop:6 },
    card: { background:'rgba(15,23,42,0.9)', border:'1px solid rgba(148,163,184,0.1)', borderRadius:14, overflow:'hidden', marginBottom:24 },
    cardHead: { padding:'16px 20px', borderBottom:'1px solid rgba(148,163,184,0.1)' },
    cardTitle: { margin:0, fontSize:16, fontWeight:700, color:'#f8fafc' },
    cardSub: { margin:'3px 0 0', fontSize:12, color:'#64748b' },
    btn: (active, color) => ({ padding:'8px 16px', borderRadius:7, border: active ? `1px solid ${color||'#3b82f6'}` : '1px solid rgba(148,163,184,0.15)', background: active ? `${color||'#3b82f6'}22` : 'rgba(30,41,59,0.6)', color: active ? (color ? '#fff' : '#93c5fd') : '#94a3b8', cursor:'pointer', fontWeight:600, fontSize:13, transition:'all 0.15s' }),
    th: { padding:'8px 6px', fontSize:10, fontWeight:700, color:'#94a3b8', textAlign:'center', borderBottom:'2px solid rgba(148,163,184,0.15)', letterSpacing:0.5 },
    td: (bg, tc) => ({ padding:'5px 3px', textAlign:'center', fontSize:10, fontWeight:600, color:tc, background:bg, transition:'all 0.15s', borderRadius:2 }),
    stickyL: (left, z) => ({ position:'sticky', left, zIndex:z||1, background:'#0f172a' }),
  };

  return (
    <div style={sty.page}>
      <div style={sty.wrap}>
        {/* Header */}
        <div style={{ textAlign:'center', marginBottom:28 }}>
          <div style={sty.badge}>MRCDADPRO</div>
          <h1 style={sty.h1}>Estudio de Cohortes</h1>
          <p style={sty.sub}>Retención de pólizas y prima neta · 2015–2025</p>
        </div>

        {/* Company Selector - Sticky */}
        <div style={{
          ...sty.card,
          marginBottom: 20,
          position: 'sticky',
          top: 0,
          zIndex: 100,
          backdropFilter: 'blur(8px)',
          background: 'rgba(15,23,42,0.95)'
        }}>
          <div style={{ padding:'14px 20px' }}>
            <div style={{ fontSize:11, fontWeight:700, color:'#94a3b8', marginBottom:10, textTransform:'uppercase', letterSpacing:1 }}>Compañía</div>
            <div style={{ display:'flex', flexWrap:'wrap', gap:6 }}>
              <button onClick={() => setSelectedCia('GLOBAL')} style={{
                ...sty.btn(selectedCia === 'GLOBAL'),
                background: selectedCia === 'GLOBAL' ? 'rgba(255,255,255,0.15)' : 'rgba(30,41,59,0.6)',
                color: selectedCia === 'GLOBAL' ? '#f8fafc' : '#94a3b8',
                border: selectedCia === 'GLOBAL' ? '1px solid rgba(255,255,255,0.3)' : '1px solid rgba(148,163,184,0.15)',
              }}>🌐 GLOBAL</button>
              {mainCompanies.filter(c => (vista === 'polizas' ? polByCia : recByCia)[c]).map(cia => (
                <button key={cia} onClick={() => setSelectedCia(cia)} style={{
                  padding:'7px 14px', borderRadius:20, fontSize:12, fontWeight:600, cursor:'pointer', transition:'all 0.15s',
                  background: selectedCia === cia ? ciaColors[cia] : 'rgba(30,41,59,0.6)',
                  color: selectedCia === cia ? '#fff' : '#94a3b8',
                  border: selectedCia === cia ? `1px solid ${ciaColors[cia]}` : '1px solid rgba(148,163,184,0.15)',
                }}>{cia}</button>
              ))}
            </div>
          </div>
        </div>

        {/* Controls */}
        <div style={{ display:'flex', justifyContent:'center', gap:8, marginBottom:20, flexWrap:'wrap' }}>
          <button onClick={() => setVista('polizas')} style={sty.btn(vista === 'polizas')}>📋 Pólizas (Nº)</button>
          <button onClick={() => setVista('recibos')} style={sty.btn(vista === 'recibos')}>💰 Prima Neta (€)</button>
          <button onClick={() => setShowPct(!showPct)} style={{
            ...sty.btn(showPct, '#f59e0b'),
            color: showPct ? '#fcd34d' : '#94a3b8',
          }}>{showPct ? '% Retención activo' : 'Mostrar % retención'}</button>
        </div>

        {/* Cohort Heatmap */}
        <div style={sty.card}>
          <div style={sty.cardHead}>
            <h2 style={sty.cardTitle}>
              {selectedCia === 'GLOBAL' ? 'Todas las compañías' : selectedCia} — {vista === 'polizas' ? 'Nº Pólizas' : 'Prima Neta (€)'} {showPct && '· % Retención'}
            </h2>
            <p style={sty.cardSub}>Filas: año de alta (POL_PrimerEfecto) · Columnas: año con recibo activo (sit. 1,5,6) · Sin recibos anteriores al primer efecto</p>
          </div>
          <div style={{ overflowX:'auto', padding:'0 0 12px' }}>
            {cohortYears.length === 0 ? (
              <p style={{ padding:20, textAlign:'center', color:'#64748b' }}>No hay datos para esta compañía en esta vista.</p>
            ) : (
              <table style={{ borderCollapse:'collapse', width:'100%', minWidth:900 }}>
                <thead>
                  <tr>
                    <th style={{ ...sty.th, ...sty.stickyL(0,2), textAlign:'left', minWidth:60 }}>Cohorte</th>
                    <th style={{ ...sty.th, ...sty.stickyL(60,2), minWidth:55 }}>Inicio</th>
                    {years.map(y => <th key={y} style={{ ...sty.th, minWidth:48 }}>{y}</th>)}
                  </tr>
                </thead>
                <tbody>
                  {cohortYears.map(cy => {
                    const row = data[cy];
                    if (!row) return null;
                    const init = getInit(row);
                    return (
                      <tr key={cy} style={{ borderBottom:'1px solid rgba(148,163,184,0.04)' }}>
                        <td style={{ ...sty.stickyL(0), padding:'7px 10px', fontWeight:700, fontSize:13, color:'#e2e8f0' }}>{cy}</td>
                        <td style={{ ...sty.stickyL(60), padding:'7px 6px', textAlign:'center', fontWeight:700, fontSize:11, color:'#93c5fd' }}>{fmtInit(init, isRec)}</td>
                        {row.map((v, idx) => {
                          const displayVal = showPct && init > 0 && v > 0 ? (v / init * 100) : v;
                          return (
                            <td key={idx} style={sty.td(getColor(v, init), getTextColor(v, init))}>
                              {fmt(showPct && init > 0 && v > 0 ? (v/init*100) : v, isRec && !showPct)}
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}
          </div>
        </div>

        {/* Legend */}
        <div style={{ display:'flex', justifyContent:'center', gap:14, marginBottom:24, flexWrap:'wrap' }}>
          <span style={{ fontSize:11, color:'#64748b' }}>Retención:</span>
          {[{l:'95%+',c:'rgba(30,64,175,0.85)'},{l:'80%+',c:'rgba(37,99,235,0.75)'},{l:'60%+',c:'rgba(59,130,246,0.6)'},{l:'40%+',c:'rgba(96,165,250,0.45)'},{l:'20%+',c:'rgba(147,197,253,0.35)'},{l:'<20%',c:'rgba(219,234,254,0.2)'}].map((x,i) => (
            <div key={i} style={{ display:'flex', alignItems:'center', gap:5 }}>
              <div style={{ width:12, height:12, borderRadius:3, background:x.c }} />
              <span style={{ fontSize:10, color:'#94a3b8' }}>{x.l}</span>
            </div>
          ))}
        </div>

        {/* Retention Summary */}
        <div style={sty.card}>
          <div style={sty.cardHead}>
            <h2 style={sty.cardTitle}>Resumen de Retención por Cohorte (Pólizas) — {selectedCia === 'GLOBAL' ? 'Todas' : selectedCia}</h2>
          </div>
          <div style={{ overflowX:'auto' }}>
            {(() => {
              const polData = selectedCia === 'GLOBAL' ? polGlobal : (polByCia[selectedCia] || {});
              const cys = Object.keys(polData).map(Number).sort((a,b) => a - b).filter(cy => getInit(polData[cy]) >= 5);
              if (cys.length === 0) return <p style={{ padding:20, textAlign:'center', color:'#64748b' }}>Sin datos suficientes.</p>;
              return (
                <table style={{ borderCollapse:'collapse', width:'100%' }}>
                  <thead>
                    <tr>
                      {['Cohorte','Inicio','Año 1','Año 2','Año 3','Año 5','Vivas 2025','Ret.'].map(h => (
                        <th key={h} style={{ ...sty.th, textAlign: h === 'Cohorte' ? 'left' : 'right', padding:'10px 12px' }}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {cys.map(cy => {
                      const row = polData[cy];
                      const init = getInit(row);
                      const cyIdx = years.indexOf(cy);
                      const val = (offset) => cyIdx + offset < 11 ? row[cyIdx + offset] : null;
                      const pct = (v) => v !== null && init > 0 ? (v / init * 100).toFixed(0) + '%' : '—';
                      const actual = row[10]; // 2025
                      const ret = init > 0 ? (actual / init * 100) : 0;
                      return (
                        <tr key={cy} style={{ borderBottom:'1px solid rgba(148,163,184,0.04)' }}>
                          <td style={{ padding:'9px 12px', fontWeight:700, fontSize:13, color:'#e2e8f0' }}>{cy}</td>
                          <td style={{ padding:'9px 12px', textAlign:'right', fontSize:12, color:'#93c5fd', fontWeight:600 }}>{init}</td>
                          <td style={{ padding:'9px 12px', textAlign:'right', fontSize:12, color:'#cbd5e1' }}>{pct(val(1))}</td>
                          <td style={{ padding:'9px 12px', textAlign:'right', fontSize:12, color:'#cbd5e1' }}>{pct(val(2))}</td>
                          <td style={{ padding:'9px 12px', textAlign:'right', fontSize:12, color:'#cbd5e1' }}>{pct(val(3))}</td>
                          <td style={{ padding:'9px 12px', textAlign:'right', fontSize:12, color:'#cbd5e1' }}>{pct(val(5))}</td>
                          <td style={{ padding:'9px 12px', textAlign:'right', fontSize:12, color:'#f8fafc', fontWeight:600 }}>{actual}</td>
                          <td style={{ padding:'9px 12px', textAlign:'right' }}>
                            <div style={{ display:'flex', alignItems:'center', justifyContent:'flex-end', gap:6 }}>
                              <div style={{ width:50, height:5, background:'rgba(148,163,184,0.1)', borderRadius:3, overflow:'hidden' }}>
                                <div style={{ width: Math.min(ret,100)+'%', height:'100%', background: ret>50?'#10b981':ret>20?'#f59e0b':'#ef4444', borderRadius:3 }} />
                              </div>
                              <span style={{ fontSize:11, fontWeight:700, color: ret>50?'#10b981':ret>20?'#f59e0b':'#ef4444', minWidth:30 }}>{ret.toFixed(0)}%</span>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              );
            })()}
          </div>
        </div>

        {/* Retention Summary - Prima Neta */}
        <div style={sty.card}>
          <div style={sty.cardHead}>
            <h2 style={sty.cardTitle}>Resumen de Retención por Cohorte (Prima Neta) — {selectedCia === 'GLOBAL' ? 'Todas' : selectedCia}</h2>
          </div>
          <div style={{ overflowX:'auto' }}>
            {(() => {
              const recData = selectedCia === 'GLOBAL' ? recGlobal : (recByCia[selectedCia] || {});
              const cys = Object.keys(recData).map(Number).sort((a,b) => a - b).filter(cy => getInit(recData[cy]) >= 1000);
              if (cys.length === 0) return <p style={{ padding:20, textAlign:'center', color:'#64748b' }}>Sin datos suficientes.</p>;
              const fmtMoney = (v) => {
                if (v >= 1000000) return (v/1000000).toFixed(1) + 'M';
                if (v >= 1000) return (v/1000).toFixed(0) + 'k';
                return v.toFixed(0);
              };
              return (
                <table style={{ borderCollapse:'collapse', width:'100%' }}>
                  <thead>
                    <tr>
                      {['Cohorte','Inicio','Año 1','Año 2','Año 3','Año 5','PN 2025','Ret.'].map(h => (
                        <th key={h} style={{ ...sty.th, textAlign: h === 'Cohorte' ? 'left' : 'right', padding:'10px 12px' }}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {cys.map(cy => {
                      const row = recData[cy];
                      const init = getInit(row);
                      const cyIdx = years.indexOf(cy);
                      const val = (offset) => cyIdx + offset < 11 ? row[cyIdx + offset] : null;
                      const pct = (v) => v !== null && init > 0 ? (v / init * 100).toFixed(0) + '%' : '—';
                      const actual = row[10]; // 2025
                      const ret = init > 0 ? (actual / init * 100) : 0;
                      return (
                        <tr key={cy} style={{ borderBottom:'1px solid rgba(148,163,184,0.04)' }}>
                          <td style={{ padding:'9px 12px', fontWeight:700, fontSize:13, color:'#e2e8f0' }}>{cy}</td>
                          <td style={{ padding:'9px 12px', textAlign:'right', fontSize:12, color:'#93c5fd', fontWeight:600 }}>{fmtMoney(init)}</td>
                          <td style={{ padding:'9px 12px', textAlign:'right', fontSize:12, color:'#cbd5e1' }}>{pct(val(1))}</td>
                          <td style={{ padding:'9px 12px', textAlign:'right', fontSize:12, color:'#cbd5e1' }}>{pct(val(2))}</td>
                          <td style={{ padding:'9px 12px', textAlign:'right', fontSize:12, color:'#cbd5e1' }}>{pct(val(3))}</td>
                          <td style={{ padding:'9px 12px', textAlign:'right', fontSize:12, color:'#cbd5e1' }}>{pct(val(5))}</td>
                          <td style={{ padding:'9px 12px', textAlign:'right', fontSize:12, color:'#f8fafc', fontWeight:600 }}>{fmtMoney(actual)}</td>
                          <td style={{ padding:'9px 12px', textAlign:'right' }}>
                            <div style={{ display:'flex', alignItems:'center', justifyContent:'flex-end', gap:6 }}>
                              <div style={{ width:50, height:5, background:'rgba(148,163,184,0.1)', borderRadius:3, overflow:'hidden' }}>
                                <div style={{ width: Math.min(ret,100)+'%', height:'100%', background: ret>50?'#10b981':ret>20?'#f59e0b':'#ef4444', borderRadius:3 }} />
                              </div>
                              <span style={{ fontSize:11, fontWeight:700, color: ret>50?'#10b981':ret>20?'#f59e0b':'#ef4444', minWidth:30 }}>{ret.toFixed(0)}%</span>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              );
            })()}
          </div>
        </div>

        {/* Proyector de Prima Neta a 5 Años */}
        <div style={sty.card}>
          <div style={sty.cardHead}>
            <h2 style={sty.cardTitle}>
              <span style={{ marginRight: 8 }}>📊</span>
              Proyector de Prima Neta a 5 Años — {selectedCia === 'GLOBAL' ? 'Patrón Global' : selectedCia}
            </h2>
            <p style={sty.cardSub}>
              Proyección basada en patrones de retención históricos de {selectedCia === 'GLOBAL' ? 'todas las compañías' : selectedCia}
            </p>
          </div>

          <div style={{ padding: '20px' }}>
            {/* Input Section */}
            <div style={{ display: 'flex', gap: 20, marginBottom: 24, flexWrap: 'wrap', alignItems: 'flex-end' }}>
              {/* Prima Neta Input */}
              <div style={{ flex: '1 1 200px', minWidth: 180 }}>
                <label style={{ display: 'block', fontSize: 11, fontWeight: 700, color: '#94a3b8', marginBottom: 8, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                  Prima Neta Inicial (€)
                </label>
                <input
                  type="text"
                  value={primaInicial}
                  onChange={(e) => {
                    const val = e.target.value.replace(/[^0-9.,]/g, '');
                    setPrimaInicial(val);
                  }}
                  placeholder="Ej: 100000"
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    borderRadius: 8,
                    border: '1px solid rgba(148,163,184,0.2)',
                    background: 'rgba(30,41,59,0.8)',
                    color: '#f8fafc',
                    fontSize: 14,
                    fontWeight: 600,
                    outline: 'none',
                  }}
                />
                <div style={{ fontSize: 9, color: '#64748b', marginTop: 4 }}>€</div>
              </div>

              {/* Comision Producción Input */}
              <div style={{ flex: '1 1 120px', minWidth: 100 }}>
                <label style={{ display: 'block', fontSize: 11, fontWeight: 700, color: '#94a3b8', marginBottom: 8, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                  % Producción
                </label>
                <input
                  type="number"
                  value={comisionProduccion}
                  onChange={(e) => setComisionProduccion(e.target.value)}
                  placeholder="Ej: 27"
                  min="0"
                  max="100"
                  step="0.5"
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    borderRadius: 8,
                    border: '1px solid rgba(16,185,129,0.3)',
                    background: 'rgba(30,41,59,0.8)',
                    color: '#a7f3d0',
                    fontSize: 14,
                    fontWeight: 600,
                    outline: 'none',
                  }}
                />
                <div style={{ fontSize: 9, color: '#64748b', marginTop: 4 }}>Año 1</div>
              </div>

              {/* Comision Cartera Input */}
              <div style={{ flex: '1 1 120px', minWidth: 100 }}>
                <label style={{ display: 'block', fontSize: 11, fontWeight: 700, color: '#94a3b8', marginBottom: 8, textTransform: 'uppercase', letterSpacing: 0.5 }}>
                  % Cartera
                </label>
                <input
                  type="number"
                  value={comisionCartera}
                  onChange={(e) => setComisionCartera(e.target.value)}
                  placeholder="Ej: 22"
                  min="0"
                  max="100"
                  step="0.5"
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    borderRadius: 8,
                    border: '1px solid rgba(59,130,246,0.3)',
                    background: 'rgba(30,41,59,0.8)',
                    color: '#93c5fd',
                    fontSize: 14,
                    fontWeight: 600,
                    outline: 'none',
                  }}
                />
                <div style={{ fontSize: 9, color: '#64748b', marginTop: 4 }}>Años 2-5</div>
              </div>

              {/* Retention Pattern Info */}
              <div style={{ flex: '2 1 300px', background: 'rgba(59,130,246,0.1)', borderRadius: 8, padding: '12px 16px', border: '1px solid rgba(59,130,246,0.2)' }}>
                <div style={{ fontSize: 10, fontWeight: 700, color: '#60a5fa', marginBottom: 6, textTransform: 'uppercase' }}>
                  Patrón de Retención Calculado ({selectedCia})
                </div>
                <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
                  {[1,2,3,4,5].map(y => (
                    <span key={y} style={{ fontSize: 11, color: '#93c5fd' }}>
                      Año {y}: <strong style={{ color: '#f8fafc' }}>{calcRetentionPatterns[y]?.toFixed(1) || '—'}%</strong>
                    </span>
                  ))}
                </div>
              </div>
            </div>

            {/* Results Table */}
            {proyeccion5Anios && proyeccion5Anios.proyecciones.length > 0 ? (
              <div style={{ overflowX: 'auto' }}>
                <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                  <thead>
                    <tr>
                      <th style={{ ...sty.th, textAlign: 'center', padding: '12px 16px' }}>Año</th>
                      <th style={{ ...sty.th, textAlign: 'right', padding: '12px 16px' }}>Retención</th>
                      <th style={{ ...sty.th, textAlign: 'right', padding: '12px 16px' }}>Prima Neta Proyectada</th>
                      <th style={{ ...sty.th, textAlign: 'right', padding: '12px 16px' }}>Comisión</th>
                    </tr>
                  </thead>
                  <tbody>
                    {proyeccion5Anios.proyecciones.map((p, idx) => (
                      <tr key={p.ano} style={{ borderBottom: '1px solid rgba(148,163,184,0.06)', background: idx % 2 === 0 ? 'transparent' : 'rgba(30,41,59,0.3)' }}>
                        <td style={{ padding: '14px 16px', textAlign: 'center', fontWeight: 700, fontSize: 14, color: '#f8fafc' }}>
                          Año {p.ano}
                          {p.ano === 1 && <span style={{ fontSize: 9, color: '#a7f3d0', marginLeft: 4 }}>(Prod)</span>}
                          {p.ano > 1 && <span style={{ fontSize: 9, color: '#93c5fd', marginLeft: 4 }}>(Cart)</span>}
                        </td>
                        <td style={{ padding: '14px 16px', textAlign: 'right', fontSize: 13 }}>
                          <span style={{ color: p.retencionPct > 60 ? '#10b981' : p.retencionPct > 30 ? '#f59e0b' : '#ef4444', fontWeight: 600 }}>
                            {p.retencionPct.toFixed(1)}%
                          </span>
                        </td>
                        <td style={{ padding: '14px 16px', textAlign: 'right', fontSize: 13, color: '#93c5fd', fontWeight: 600 }}>
                          {p.primaProyectada.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €
                        </td>
                        <td style={{ padding: '14px 16px', textAlign: 'right', fontSize: 13, color: p.ano === 1 ? '#a7f3d0' : '#93c5fd', fontWeight: 600 }}>
                          {p.comision.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €
                          <span style={{ fontSize: 10, color: '#64748b', marginLeft: 4 }}>({p.comisionPct}%)</span>
                        </td>
                      </tr>
                    ))}

                    {/* Totals Row */}
                    <tr style={{ borderTop: '2px solid rgba(148,163,184,0.2)', background: 'rgba(59,130,246,0.1)' }}>
                      <td colSpan={2} style={{ padding: '16px', fontWeight: 700, fontSize: 14, color: '#f8fafc' }}>
                        TOTAL ACUMULADO (5 años)
                      </td>
                      <td style={{ padding: '16px', textAlign: 'right', fontSize: 15, color: '#60a5fa', fontWeight: 700 }}>
                        {proyeccion5Anios.totales.primaAcumulada.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €
                      </td>
                      <td style={{ padding: '16px', textAlign: 'right', fontSize: 15, color: '#34d399', fontWeight: 700 }}>
                        {proyeccion5Anios.totales.comisionAcumulada.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €
                      </td>
                    </tr>
                  </tbody>
                </table>

                {/* Summary Boxes */}
                <div style={{ marginTop: 20, display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 16 }}>
                  <div style={{ background: 'linear-gradient(135deg, rgba(59,130,246,0.2), rgba(37,99,235,0.1))', borderRadius: 10, padding: '16px 20px', border: '1px solid rgba(59,130,246,0.3)' }}>
                    <div style={{ fontSize: 10, fontWeight: 700, color: '#60a5fa', textTransform: 'uppercase', marginBottom: 6 }}>
                      Prima Inicial
                    </div>
                    <div style={{ fontSize: 22, fontWeight: 700, color: '#f8fafc' }}>
                      {(parseFloat(primaInicial.replace(/,/g, '').replace(/\./g, '')) || 0).toLocaleString('es-ES')} €
                    </div>
                  </div>

                  <div style={{ background: 'linear-gradient(135deg, rgba(16,185,129,0.2), rgba(5,150,105,0.1))', borderRadius: 10, padding: '16px 20px', border: '1px solid rgba(16,185,129,0.3)' }}>
                    <div style={{ fontSize: 10, fontWeight: 700, color: '#34d399', textTransform: 'uppercase', marginBottom: 6 }}>
                      Comisión Total (5 años)
                    </div>
                    <div style={{ fontSize: 22, fontWeight: 700, color: '#a7f3d0' }}>
                      {proyeccion5Anios.totales.comisionAcumulada.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €
                    </div>
                  </div>

                  <div style={{ background: 'linear-gradient(135deg, rgba(249,115,22,0.2), rgba(234,88,12,0.1))', borderRadius: 10, padding: '16px 20px', border: '1px solid rgba(249,115,22,0.3)' }}>
                    <div style={{ fontSize: 10, fontWeight: 700, color: '#fb923c', textTransform: 'uppercase', marginBottom: 6 }}>
                      Retención Año 5
                    </div>
                    <div style={{ fontSize: 22, fontWeight: 700, color: '#fed7aa' }}>
                      {calcRetentionPatterns[5]?.toFixed(1) || '—'}%
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div style={{ textAlign: 'center', padding: '40px 20px', color: '#64748b', background: 'rgba(30,41,59,0.3)', borderRadius: 8 }}>
                <div style={{ fontSize: 32, marginBottom: 12 }}>📈</div>
                <div style={{ fontSize: 14 }}>
                  Introduce una Prima Neta inicial para ver la proyección a 5 años
                </div>
                <div style={{ fontSize: 12, marginTop: 8, color: '#475569' }}>
                  Los cálculos se basan en patrones de retención reales de {selectedCia === 'GLOBAL' ? 'todas las compañías' : selectedCia}
                </div>
              </div>
            )}
          </div>
        </div>

        <p style={{ textAlign:'center', fontSize:11, color:'#475569', marginTop:16 }}>
          Ramo MRCDADPRO · Recibos en situación 1,5,6 · Excluidos recibos anteriores a POL_PrimerEfecto
        </p>
      </div>
    </div>
  );
}
